// Utils
import ComparisonItem from '@/types/comparison-item';
import { COMPARISON_ITEM_TYPES } from './constants';
import { isUpRisk } from './risk-profiles';

export enum USAGE_TYPES {
  ADD_MARKUP = 'ADD_MARKUP',
  ADD_TO_COMPARISON = 'ADD_TO_COMPARISON',
  ADD_TO_PORTFOLIO = 'ADD_TO_PORTFOLIO',
  ATTACH_OMNI_RISK_PROFILE_TO_COMPARISON = 'ATTACH_OMNI_RISK_PROFILE_TO_COMPARISON',
  ATTACH_RISK_PROFILE_TO_COMPARISON = 'ATTACH_RISK_PROFILE_TO_COMPARISON',
  CANCEL_AI_STATEMENT_READER_PROCESS = 'CANCEL_AI_STATEMENT_READER_PROCESS',
  COMPARISON_MARK_SHARED_WITH_CLIENT = 'COMPARISON_MARK_SHARED_WITH_CLIENT',
  DISMISS_UNLOCK_AI_STATEMENT_READER_FROM_MARKETING_BANNER = 'DISMISS_UNLOCK_AI_STATEMENT_READER_FROM_MARKETING_BANNER',
  DISPLAY_AI_STATEMENT_READER_MARKETING_BANNER = 'DISPLAY_AI_STATEMENT_READER_MARKETING_BANNER',
  DOCUMENTS_PROCESSED_BY_AI_STATEMENT_READER = 'DOCUMENTS_PROCESSED_BY_AI_STATEMENT_READER',
  DOWNLOAD_PROPOSAL = 'DOWNLOAD_PROPOSAL',
  ERROR_IN_AI_STATEMENT_READER = 'ERROR_IN_AI_STATEMENT_READER',
  HISTORICAL_SCENARIOS_USAGE = 'HISTORICAL_SCENARIOS_USAGE',
  NEW_COMPARISON = 'NEW_COMPARISON',
  NEW_PORTFOLIO = 'NEW_PORTFOLIO',
  OPEN_EXPORT_PRESENTATION_MODAL = 'OPEN_EXPORT_PRESENTATION_MODAL',
  OPEN_HELP_CENTER = 'OPEN_HELP_CENTER',
  REMOVE_FROM_COMPARISON = 'REMOVE_FROM_COMPARISON',
  REMOVE_FROM_PORTFOLIO = 'REMOVE_FROM_PORTFOLIO',
  RESET_MARKUP = 'RESET_MARKUP',
  SAVE_AI_STATEMENT_PORTFOLIO = 'SAVE_AI_STATEMENT_PORTFOLIO',
  UNLOCK_AI_STATEMENT_READER_FROM_MARKETING_BANNER = 'UNLOCK_AI_STATEMENT_READER_FROM_MARKETING_BANNER',
}

export type ComparisonItemEvent = USAGE_TYPES.ADD_TO_COMPARISON | USAGE_TYPES.REMOVE_FROM_COMPARISON;

export type PortfolioHoldingEvent = USAGE_TYPES.ADD_TO_PORTFOLIO | USAGE_TYPES.REMOVE_FROM_PORTFOLIO;

export const serializePortfolio = (item: ComparisonItem) => {
  const riskProfileUpRisk = item.riskProfile?.upRisk;
  return {
    portfolioId: item._id,
    portfolioCorrelationId: item.source?.correlationId,
    holdings: item.holdings.map(holding => ({
      type: holding.type,
      symbol: holding.symbol,
      name: holding.name && holding.name['en-CA'],
      weight: holding.weight,
    })),
    enterpriseId: item.enterprise && item.enterprise._id,
    // the first group should be enough
    groupId: item.enterpriseGroups && item.enterpriseGroups.length > 0 ? item.enterpriseGroups[0] : undefined,
    contactId: item.contact,
    isEnterpriseModel: !!item.enterprise || (item.enterpriseGroups && item.enterpriseGroups.length > 0),
    isUpRisk: isUpRisk(riskProfileUpRisk),
  };
};

export const serializeGroup = (item: ComparisonItem) => ({
  name: item.name['en-CA'],
  products: item.groupItems?.map(groupItem => ({
    dollars: groupItem.dollars,
    fee: groupItem.fee,
    itemId: groupItem.itemId,
  })),
});

export const serializeFund = (item: ComparisonItem) => ({
  symbol: item.holdings[0] && item.holdings[0].symbol,
  name: item.name['en-CA'],
});

export const serializeStock = (item: ComparisonItem) => ({
  symbol: item.holdings[0] && item.holdings[0].symbol,
  name: item.name['en-CA'],
});

export const serializeAlt = (item: ComparisonItem) => ({
  name: item.name['en-CA'],
});

export const serializeBenchmark = (item: ComparisonItem) => ({
  holdings: item.holdings.map(holding => ({
    type: holding.type,
    symbol: holding.symbol,
    name: holding.name && holding.name['en-CA'],
    weight: holding.weight,
  })),
});

export const SERIALIZERS = {
  [COMPARISON_ITEM_TYPES.PORTFOLIO]: serializePortfolio,
  [COMPARISON_ITEM_TYPES.FUND]: serializeFund,
  [COMPARISON_ITEM_TYPES.STOCK]: serializeStock,
  [COMPARISON_ITEM_TYPES.BENCHMARK]: serializeBenchmark,
  [COMPARISON_ITEM_TYPES.GROUP]: serializeGroup,
  [COMPARISON_ITEM_TYPES.ALT]: serializeAlt,
};

export const serializeComparisonItem = (item: ComparisonItem) => {
  const serializeFn = SERIALIZERS[item.type];
  return {
    type: item.type,
    ...serializeFn(item),
  };
};
